import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaCss from 'single-spa-css';
import '@agencypmg/alli/dist/style/alli.css';
import './loader.css';

export * from '@agencypmg/alli';

const lifecycles = singleSpaCss({
    webpackExtractedCss: true,
    shouldUnmount: false,
    timeout: 10000,
});

function removeLoader() {
    const loader = document.getElementById('alli-loader');
    if (!loader) {
        return;
    }

    const removeLoader = () => {
        loader.removeEventListener('transitionend', removeLoader);
        loader.remove();
    };

    loader.addEventListener('transitionend', removeLoader);

    loader.classList.add('alli-loader-transition');

    return Promise.resolve();
}

export const { bootstrap, unmount } = lifecycles;

export const mount = [
    lifecycles.mount,
    removeLoader,
];
